import { useState } from "react";
import { Link } from "react-router-dom";
import { Copy, Check, ExternalLink } from "lucide-react";
import ShareButton from "@/components/ShareButton";

export default function CouponCard({ coupon, index = 0, hideShare = false }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    if (!coupon.code) return;
    navigator.clipboard?.writeText(coupon.code).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <article data-testid="coupon-card"
      className="bg-white rounded-xl border border-neutral-200 p-5 flex flex-col hover:shadow-md hover:-translate-y-1 transition-[transform,box-shadow] duration-200 fade-up"
      style={{ animationDelay: `${Math.min(index * 60, 400)}ms` }}>
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          {coupon.store_name && <span className="text-xs tracking-[0.15em] uppercase font-bold text-neutral-400">{coupon.store_name}</span>}
          <h3 className="font-display font-semibold text-ink-900 leading-snug mt-1">
            <Link to={`/coupon/${coupon.id}`} data-testid="coupon-detail-link" className="hover:text-brand transition-colors">{coupon.title}</Link>
          </h3>
        </div>
        <span className="shrink-0 bg-brand/10 text-brand font-display font-extrabold text-sm px-3 py-1.5 rounded-md whitespace-nowrap">{coupon.discount || "DEAL"}</span>
      </div>
      {coupon.description && <p className="text-sm text-neutral-500 mb-4 line-clamp-2">{coupon.description}</p>}
      <div className="mt-auto flex items-center gap-2">
        {coupon.code ? (
          <button data-testid="coupon-copy-btn" data-allow-copy onClick={copy}
            className="flex-1 flex items-center justify-center gap-2 h-11 rounded-full border-2 border-dashed border-brand/40 bg-brand/5 text-brand font-mono font-bold text-sm hover:bg-brand/10 transition-colors">
            {copied ? <><Check className="w-4 h-4" /> Copied!</> : <><Copy className="w-4 h-4" /> {coupon.code}</>}
          </button>
        ) : <div className="flex-1" />}
        <a data-testid="coupon-cta" href={coupon.affiliate_url} target="_blank" rel="noopener noreferrer sponsored"
          data-aff-title={coupon.title} data-aff-kind="coupon"
          className="flex items-center justify-center gap-1.5 h-11 px-5 rounded-full bg-brand hover:bg-brand-hover text-white font-semibold text-sm transition-colors">
          Shop <ExternalLink className="w-3.5 h-3.5" />
        </a>
        {!hideShare && <ShareButton path={`/coupon/${coupon.id}`} title={`${coupon.store_name ? `${coupon.store_name}: ` : ""}${coupon.title}`} image={coupon.image_url || coupon.logo_url} testid="coupon-share-btn" />}
      </div>
      {coupon.expiry && <p className="text-xs text-neutral-400 mt-3">Expires {coupon.expiry}</p>}
    </article>
  );
}
